module.exports = __webpack_public_path__ + "img/ruby1.b247afa7.png";